import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";
import { useMemo } from "react";

import { $templatePreviewImage } from "../../internal/templates/template-preview-image.atom";

/**
 * Hook to get a template's preview image with authentication.
 * Returns cached data URL or null, with loading state.
 *
 * @param templateId - The template ID to fetch the preview for, or null to skip
 * @returns Object with dataUrl (string | null), isLoading, and error
 */
export const useTemplatePreviewImage = (templateId: string | null) => {
	const loadableAtom = useMemo(() => loadable($templatePreviewImage(templateId)), [templateId]);

	const result = useAtomValue(loadableAtom);

	return {
		dataUrl: result.state === "hasData" ? result.data : null,
		isLoading: result.state === "loading",
		error: result.state === "hasError" ? result.error : null,
	};
};
